import Rollbar from '../../configure_rollbar';

export const setPerson = ({ email, id }) =>
  Rollbar.configure({
    payload: {
      person: {
        id,
        email,
      },
    },
  });

export const clearPerson = () =>
  Rollbar.configure({
    payload: {
      person: {
        id: null,
        email: null,
      },
    },
  });
